import BeauHeadshot from "../Media/BeauHeadshot.png";
import AnliHeadshot from "../Media/AnliHeadshot.png";

export const UgandaBoard = [
  {
    id: "beau",
    name: "Beau",
    image: BeauHeadshot,
    description: "Masters",
    major: "Civil Engineering",
  },
  {
    id: "anli",
    name: "Anli",
    image: AnliHeadshot,
    description: "4th year",
    major: "Mechanical Engineering",
  },
];
